//#region ng
import {
  Component,
  EventEmitter,
  Input,
  Output,
  inject,
  signal
} from '@angular/core';
//#endregion

//#region 3rd
import {
  Subject,
  takeUntil
} from 'rxjs';
//#endregion

//#region models
import { ILoja } from '../../_shared/_mercadeiro/_misc/_models/_interfaces/_cols';
//#endregion

//#region libs
import { onDestroy } from '../../_shared/_core/_ng/_libs';
//#endregion

//#region services
import { AppService } from '../../services';
import { LojasService } from '../../_shared/_mercadeiro/_ng/_services';
import { CorMessagesService } from '../../_shared/_core/_ng/_services';
//#endregion

//#region stores
import { LojasStore } from '../../_shared/_mercadeiro/_ng/_stores';
//#endregion

@Component({
  selector: 'app-loja-m-header',
  templateUrl: './loja-m-header.component.html',
  styleUrls: ['./loja-m-header.component.scss']
})
export class AppLojaMHeaderComponent {
  //#region actions
  #destroyAction$: Subject<void> = onDestroy();
  //#endregion

  //#region inputs
  // showReturn
  @Input() showReturn: boolean = false;
  // showMenu
  @Input() showMenu: boolean = true;
  //#endregion

  //#region outputs
  @Output() returnClick$ = new EventEmitter<void>();
  //#endregion

  //#region publics
  loja = signal<ILoja>(null);
  //#endregion

  //#region injects
  #lojasServ = inject(LojasService);
  #lojasStore = inject(LojasStore);
  #msgServ = inject(CorMessagesService);
  //#endregion

  //#region lifecycles
  ngOnInit(): void {
    this.#msgServ.send();
    this.#lojasStore.lojaStateChanged$
      .pipe(takeUntil(this.#destroyAction$))
      .subscribe((loja: ILoja) => this.loja.set(!!loja ? this.#lojasServ.fix(loja) : null));
  }
  //#endregion

  //#region methods
  onMenuLojaOpenClick() {
    AppService.menuLojaStatus$.next(true);
  }
}
